/** Center panel: mobile header + tab bar + editor area */

import { Menu, PanelRight, Search } from 'lucide-react'
import { useAppStore } from '../../stores/app-store'
import { useIsRailDrawer } from '../../hooks/use-is-rail-drawer'
import { TabBar } from '../editor/tab-bar'
import { Editor } from '../editor/editor'
import { WelcomeScreen } from '../editor/welcome-screen'
import { cn } from '../../lib/utils'
import { BrandLogo } from '../shared/brand-logo'

export function MainPanel() {
  const {
    openTabs,
    activeTabId,
    theme,
    setMobileSidebarOpen,
    setMobileMetadataOpen,
    toggleCommandPalette,
  } = useAppStore()
  const drawerMode = useIsRailDrawer()
  const isDark = theme === 'dark'

  const activeTab = openTabs.find((t) => t.id === activeTabId) ?? null

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      {/* Mobile header */}
      {drawerMode && (
        <div
          className={cn(
            'flex items-center justify-between px-2 py-2 border-b shrink-0',
            isDark ? 'border-white/[0.06] bg-surface-1' : 'border-neutral-200 bg-white',
          )}
        >
          <button
            onClick={() => setMobileSidebarOpen(true)}
            className={cn(
              'flex min-h-11 min-w-11 items-center justify-center rounded-lg p-2',
              isDark
                ? 'text-neutral-400 active:bg-surface-3'
                : 'text-neutral-500 active:bg-neutral-100',
            )}
            aria-label="Open document navigation"
          >
            <Menu className="h-5 w-5" />
          </button>

          <BrandLogo size="xs" />

          <div className="flex items-center gap-1">
            <button
              onClick={toggleCommandPalette}
              className={cn(
                'flex min-h-11 min-w-11 items-center justify-center rounded-lg p-2',
                isDark
                  ? 'text-neutral-400 active:bg-surface-3'
                  : 'text-neutral-500 active:bg-neutral-100',
              )}
              aria-label="Search"
            >
              <Search className="h-5 w-5" />
            </button>
            {activeTab && (
              <button
                onClick={() => setMobileMetadataOpen(true)}
                className={cn(
                  'flex min-h-11 min-w-11 items-center justify-center rounded-lg p-2',
                  isDark
                    ? 'text-neutral-400 active:bg-surface-3'
                    : 'text-neutral-500 active:bg-neutral-100',
                )}
                aria-label="Open document properties"
              >
                <PanelRight className="h-5 w-5" />
              </button>
            )}
          </div>
        </div>
      )}

      {openTabs.length > 0 && <TabBar />}
      <div className="flex-1 overflow-hidden">
        {activeTab ? (
          <Editor
            key={activeTab.documentId}
            documentId={activeTab.documentId}
            tabId={activeTab.id}
          />
        ) : (
          <WelcomeScreen />
        )}
      </div>
    </div>
  )
}
